import { createPortal } from 'react-dom';

import { useVisibleToasts } from './toastStore';
import { Toast } from './Toast';

/**
 * Globální host pro toast notifikace.
 * Zobrazuje maximálně 3 viditelné toasty, přičemž další čekají ve frontě.
 *
 * Portál do `document.body` + vysoký z-index: toasty musí být NAD okny frameworku
 * (PhoenixDesktop, z-index `10 + stackZ*100`, neomezeně roste — proto by je nízký z-index
 * schoval za samostatná okna). Zůstávají POD popup menu (DropdownMenu/MenuPopover/MenuSearch =
 * `99999999`, backdrop `99999998`) — jediné, co smí být výš.
 *
 * Built on: Custom composition over shadcn building blocks
 */
export function ToastHost() {
  const visibleToasts = useVisibleToasts();

  if (visibleToasts.length === 0) {
    return null;
  }

  return createPortal(
    // Horizontálně vycentrované v horní části obrazovky, pod hlavním menu (.legacy-menu = 32px).
    // Dřív pravý dolní roh — kolidoval s tlačítky Uložit / Zpět ve formulářích.
    <div
      className="z-phx-toast fixed top-10 left-1/2 flex max-h-screen w-full max-w-[420px] -translate-x-1/2 flex-col items-center gap-2 px-4 pb-4"
      aria-label="Notifications"
    >
      {visibleToasts.map((item) => (
        <Toast key={item.id} item={item} />
      ))}
    </div>,
    document.body
  );
}
